package dev.kuml.portal.web.components

import dev.kuml.portal.web.i18n.t
import io.kvision.core.Container
import io.kvision.html.button
import io.kvision.html.div

/**
 * Small, muted "Impressum · Datenschutz · AGB" link row -- the only place the three legally
 * required pages (§ 5 TMG / Art. 13 DSGVO / AGB, see [dev.kuml.portal.web.routing.Router]'s
 * `/impressum`, `/datenschutz` and `/agb` routes) are reachable from. Rendered both on the auth
 * screen (the first thing an unauthenticated visitor sees) and in [portalHeader] (so the pages
 * stay reachable once logged in too). Plain styled buttons, not `<a>` tags -- this codebase has no
 * existing anchor-tag usage anywhere, every other "navigation" element (the wordmark, the tab
 * buttons) is already a styled button wired to [dev.kuml.portal.web.routing.Router.navigate] via a
 * callback, so this follows that same established idiom rather than introducing a new one.
 */
public fun Container.legalLinks(
    onImpressumClick: () -> Unit,
    onDatenschutzClick: () -> Unit,
    onAgbClick: () -> Unit,
) {
    div(className = "kportal-legal-links") {
        button(t.legal.imprintLink, className = "kportal-legal-link").onClick { onImpressumClick() }
        div("·", className = "kportal-legal-sep")
        button(t.legal.privacyLink, className = "kportal-legal-link").onClick { onDatenschutzClick() }
        div("·", className = "kportal-legal-sep")
        button(t.legal.termsLink, className = "kportal-legal-link").onClick { onAgbClick() }
    }
}
